/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load TikTok Ads functions
 * */

(function (pmw, $, undefined) {

	pmw.loadTikTokPixel = () => {

		try {
			// @formatter:off
			!function (w, d, t) {
				w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};

				ttq.load(pmwDataLayer.pixels.tiktok.pixel_id);
				ttq.page();
			}(window, document, 'ttq');
			// @formatter:on

			if (
				pmwDataLayer?.pixels?.tiktok?.advanced_matching
				&& (
					pmwDataLayer?.user?.email?.sha256
					|| pmwDataLayer?.user?.phone?.sha256?.e164
				)
			) {
				let identity = {}

				// https://ads.tiktok.com/marketing_api/docs?id=1739585700402178
				if (pmwDataLayer?.user?.email?.sha256) identity.sha256_email = pmwDataLayer.user.email.sha256
				if (pmwDataLayer?.user?.phone?.sha256?.e164) identity.sha256_phone_number = pmwDataLayer.user.phone.sha256.e164

				ttq.identify(identity)
			}

			pmwDataLayer.pixels.tiktok.loaded = true

		} catch (e) {
			console.error(e)
		}
	}

	pmw.getTikTokOrderItemIds = () => {

		let orderItems = []

		Object.values(pmwDataLayer.order.items).forEach((item) => {

			let orderItem

			orderItem = {
				quantity: item.quantity,
				price   : item.price,
			}

			let itemId             = pmwDataLayer?.shop?.variations_output && 0 !== item.variation_id ? item.variation_id : item.id
			let product            = pmwDataLayer.products[itemId]
			orderItem.content_id   = pmw.getProductIdForSpecificPixel(product, "tiktok")
			orderItem.content_name = pmwDataLayer.products[itemId].name

			orderItems.push(orderItem)
		})

		return orderItems
	}

	pmw.tiktokGetEventUserData = () => {

		let user = {}

		let ttp = pmw.getCookie("_ttp")
		if (pmw.isValidTtp(ttp)) {
			user.ttp = ttp
		}

		let ttclid = pmw.getCookie("_ttclid") || pmw.retrieveData("ttclid")
		if (pmw.isValidTtclid(ttclid)) {
			user.ttclid = ttclid
		}

		if (pmwDataLayer?.pixels?.tiktok?.advanced_matching) {
			if (pmwDataLayer?.user?.email?.tiktok) user.email = pmwDataLayer.user.email.tiktok
			if (pmwDataLayer?.user?.phone?.tiktok) user.phone = pmwDataLayer.user.phone.tiktok
			if (pmwDataLayer?.user?.id?.sha256) user.external_id = pmwDataLayer.user.id.sha256
			if (navigator.userAgent) user.user_agent = navigator.userAgent
		}

		// get the BCP 47 language identifier from the browser and add it to the user data
		let locale = navigator.language || navigator.userLanguage
		if (locale) {
			user.locale = locale
		}

		return user
	}

	pmw.tiktokGetEventPageData = () => {

		let data = {
			url: window.location.href.split("?")[0],
		}

		if (pmw.retrieveData("referrer")) {
			data.referrer = pmw.makeFullUrl(pmw.retrieveData("referrer"))
		}

		return data
	}

	pmw.isValidTtp = ttp => {

		let re = new RegExp(/^[\da-zA-Z-]{20,50}$/)

		return re.test(ttp)
	}

	pmw.isValidTtclid = ttclid => {

		let re = new RegExp(/^[\da-zA-z-]{5,600}$/)

		return re.test(ttclid)
	}

	pmw.tiktokGetPropertiesFromCart = () => {

		let properties = {
			currency    : pmwDataLayer.shop.currency,
			value       : 0,
			contents    : [],
			content_type: "product",
		}

		Object.values(pmwDataLayer.cart).forEach((item) => {

			let content = {
				quantity: item.quantity,
				price   : item.price,
			}

			properties.value += item.price * item.quantity

			let dyn_r_ids = (!pmwDataLayer?.shop?.variations_output && item.is_variation && item.id !== 0) ? item.parent_id_dyn_r_ids : item.dyn_r_ids

			content.content_id   = String(dyn_r_ids[pmwDataLayer.pixels.tiktok.dynamic_remarketing.id_type])
			content.content_name = item.name

			properties.contents.push(content)
		})

		return properties
	}

	/**
	 * Check if the TikTok pixel can be fired
	 *
	 * @return {boolean}
	 */
	pmw.canFireTikTokEvent = () => {

		if (!pmwDataLayer?.pixels?.tiktok?.loaded) return false

		// If the user has not given consent for marketing, return false
		if (!pmw.consent.categories.get().marketing) return false

		return true
	}

	/**
	 * Check if the TikTok pixel can not be fired
	 *
	 * @return {boolean}
	 */
	pmw.canNotFireTikTokEvent = () => {
		return !pmw.canFireTikTokEvent()
	}

}(window.pmw = window.pmw || {}, jQuery));
